const styles = () => ({
  backgroundContentContainer: ({ backgroundContentContainer }) => ({
    backgroundColor: backgroundContentContainer,
  }),
  searchWrapper: {
    position: 'relative',
    width: '100%',
  },
  searchIcon: {
    position: 'absolute',
    top: '0',
    left: '14px',
    height: '100%',
  },
});

export default styles;
